import { render, staticRenderFns } from "./PointGiftManage.vue?vue&type=template&id=ee1e1d7c&"
import script from "./PointGiftManage.vue?vue&type=script&lang=js&"
export * from "./PointGiftManage.vue?vue&type=script&lang=js&"
import style0 from "./PointGiftManage.vue?vue&type=style&index=0&id=ee1e1d7c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1e1d7c')) {
      api.createRecord('ee1e1d7c', component.options)
    } else {
      api.reload('ee1e1d7c', component.options)
    }
    module.hot.accept("./PointGiftManage.vue?vue&type=template&id=ee1e1d7c&", function () {
      api.rerender('ee1e1d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/points/point-gift-manage/PointGiftManage.vue"
export default component.exports